import { Box, Container, Typography } from "@mui/material";
import { CSSProperties, ReactNode } from "react";

export interface ViewWrapperProps {
  title: ReactNode;
  subtitle?: ReactNode;
  image: string;
  action?: ReactNode;
  fullScreen?: boolean;
  imageStyles?: CSSProperties;
}

export function ViewWrapper({ title, subtitle, image, action, fullScreen = false, imageStyles }: ViewWrapperProps) {
  return (
    <Box
      sx={{
        height: fullScreen ? "100vh" : "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            mt: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={image} alt="View asset" style={{ maxWidth: "100%", height: 100, ...imageStyles }} />
        </Box>

        {typeof title === "string" ? (
          <Typography variant="h3" gutterBottom={!!subtitle}>
            {title}
          </Typography>
        ) : (
          title
        )}

        {subtitle && (
          <Typography variant="subtitle1" color="textSecondary">
            {subtitle}
          </Typography>
        )}

        {action && (
          <Box
            sx={{
              mt: 5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {action}
          </Box>
        )}
      </Container>
    </Box>
  );
}
